import forOwn from 'lodash/forOwn'
import get from 'lodash/get'
import isNull from 'lodash/isNull'
import { DEFAULT_FORM_ERROR_HELPER_TEXT } from '../constants'

export const collectFormErrors = (e, errors, setErrors) => {
    if (typeof e.inner === 'undefined') {
        return
    }
    let newErrorState = Object.assign({}, errors)
    e.inner.forEach(function (item) {
        newErrorState[item.path] = item.errors
    })
    setErrors(newErrorState)
}

export const addFormErrors = (errorMessage, paths, errors, setErrors) => {
    let newErrorState = Object.assign({}, errors)
    paths.forEach(function (path) {
        newErrorState[path] = [errorMessage]
    })
    setErrors(newErrorState)
}

export const addFormErrorsWithMessages = (paths, errors, setErrors) => {
    let newErrorState = Object.assign({}, errors)
    forOwn(paths, function (pathData, path) {
        newErrorState[path] = [
            get(pathData, 'errorMessage', DEFAULT_FORM_ERROR_HELPER_TEXT),
        ]
    })
    setErrors(newErrorState)
}

export const replaceFormErrors = (e, errors, setErrors) => {
    if (typeof e.inner === 'undefined') {
        return
    }
    let newErrorState = {}
    e.inner.forEach(function (item) {
        newErrorState[item.path] = item.errors
    })
    setErrors(newErrorState)
}

export const removeErrorFromPath = (path, errorsObj) => {
    let newState = Object.assign({}, errorsObj)
    delete newState[path]
    return newState
}

export const removeErrorFromPaths = (paths, errors, setErrors) => {
    let newState = Object.assign({}, errors)
    paths.forEach(function (path) {
        delete newState[path]
    })
    setErrors(newState)
}
export const removeSpecificErrorFromPaths = (paths, errors, setErrors, specificErrorText) => {
    let newState = { ...errors }; // Use spread syntax for a shallow copy of the errors object.

    paths.forEach(function (path) {
        if (Array.isArray(newState[path])) {
            // If it's an array, filter out the specific error text.
            newState[path] = newState[path].filter(error => error !== specificErrorText);

            // If the array becomes empty after filtering, delete the key.
            if (newState[path].length === 0) {
                delete newState[path];
            }
        } else {
            // If it's not an array, just delete the key.
            delete newState[path];
        }
    });

    setErrors(newState);
};

export const inputHasError = (errors, path) => {
    return !isNull(errors) && typeof errors[path] !== 'undefined'
}

export const getErrorMessage = (errors, path) => {
    return !isNull(errors) && typeof errors[path] !== 'undefined'
        ? errors[path].join(', ')
        : ''
}
